import { render } from "./AudienceGroup.vue?vue&type=template&id=abf474c8&scoped=true"
import script from "./AudienceGroup.vue?vue&type=script&lang=js"
export * from "./AudienceGroup.vue?vue&type=script&lang=js"

import "./AudienceGroup.vue?vue&type=style&index=0&id=abf474c8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf474c8"]])

export default __exports__